import { useParams } from 'react-router-dom';

/**
 * Wrapper around `useParams` which adds validation that the specified params are actually provided
 *
 * `useParams` treats params as potentially undefined because there is no way at compile time to know that
 * a component will be rendered in a route with the relevant params
 *
 * This makes not rendering in a route with the relevant params a runtime error
 * @param requiredParams The params which must be provided
 * @returns The params, without them being optional
 */
export function useRequiredParams<T extends Record<string, string>>(...requiredParams: (keyof T)[]) {
  const params = useParams<T>();

  for (const param of requiredParams) {
    if (!(param in params)) {
      throw new Error(`Component must be mounted at a route with \`${param.toString()}\` as a path param`);
    }
  }
  return params as T;
}
